import axios, { AxiosInstance } from 'axios';

let currentBaseUrl = '';
let currentToken = '';
let httpClient: AxiosInstance = createClient('', '');

function createClient(baseUrl: string, token: string): AxiosInstance {
  const client = axios.create({
    baseURL: baseUrl,
    headers: { 'Content-Type': 'application/json' },
    timeout: 15000,
  });

  if (token) {
    client.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }

  return client;
}

export function setBaseUrl(baseUrl: string) {
  if (baseUrl !== currentBaseUrl) {
    currentBaseUrl = baseUrl;
    httpClient = createClient(baseUrl, currentToken);
  }
}

export function setToken(token: string) {
  currentToken = token;
  httpClient = createClient(currentBaseUrl, token);
}

export function clearToken() {
  currentToken = '';
  httpClient = createClient(currentBaseUrl, '');
}

export function getHttpClient(): AxiosInstance {
  return httpClient;
}
